/**
 * Convertit une chaîne de caractères en snake_case.
 */
export const toSnakeCase = (input: string): string => {
  return input.trim().toLowerCase().replace(/\s+/g, "_");
};
